export default __webpack_public_path__ + "static/media/claps.cb0f93a0.svg";